import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LuckyFlushPage } from './pages/LuckyFlushPage';
import { QuizPage } from './pages/QuizPage';
import { DiagnosisPage } from './pages/DiagnosisPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <Router data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<LuckyFlushPage data-id="element-4" />} data-id="element-3" />
        <Route path="/quiz" element={<QuizPage data-id="element-6" />} data-id="element-5" />
        <Route path="/diagnosis" element={<DiagnosisPage data-id="element-8" />} data-id="element-7" />
      </Routes>
    </Router>;
}